export const theme = {
  colors: {
    bg: '#0b0f1a',
    bgElevated: '#121826',
    text: '#e6ecff',
    textDim: '#9aa4bf',
    primary: '#7c5cff',
    primaryGlow: 'rgba(2, 120, 255, 0.36)',
    accent: '#00e5ff',
    accentGlow: 'rgba(0, 255, 255, 0.3)',
    danger: '#ff4d6d',
    card: '#141b2d',
    border: 'rgba(255,255,255,0.08)'
  },
  radii: {
    sm: '10px',
    md: '16px',
    lg: '22px',
    xl: '28px'
  },
  shadows: {
    glowPrimary: '0 0 40px rgba(2, 120, 255, 0.36)',
    glowAccent: '0 0 40px rgba(0, 255, 255, 0.3)'
  }
};